import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useAuth, useProfile } from '@discovr/common';
import { brandApi } from '@/lib/api';

export function useBrandSidebarUser(): {
  userInitials: string;
  userName: string | undefined;
  userRole: string | undefined;
} {
  const { user } = useAuth();
  const { data: profile } = useProfile();
  const { data: brandProfile } = useQuery({
    queryKey: ['brand-profile'],
    queryFn: () => brandApi.getProfile(),
    staleTime: 5 * 60_000,
    enabled: !!user,
    placeholderData: keepPreviousData,
  });

  const userInitials = profile?.first_name?.[0] ?? '';
  const userName = profile
    ? `${profile.first_name ?? ''} ${profile.last_name ?? ''}`
    : undefined;
  const userRole = brandProfile?.name;

  return { userInitials, userName, userRole };
}
